import { render, staticRenderFns } from "./AgrilaoMenu.vue?vue&type=template&id=cd3dc5f2&scoped=true&"
import script from "./AgrilaoMenu.vue?vue&type=script&lang=js&"
export * from "./AgrilaoMenu.vue?vue&type=script&lang=js&"
import style0 from "./AgrilaoMenu.vue?vue&type=style&index=0&id=cd3dc5f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3dc5f2",
  null
  
)

export default component.exports